import React from "react";
import { useForm } from "react-hook-form";
import { makeStyles, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "40px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  eklogo: {
    width: "350px",
    height: "100px",
    marginInline: "auto",
  },
}));
const Agreement = (props) => {
  const { next ,previous} = props;
  const classes = useStyles();
  const { handleSubmit, register, errors } = useForm();
  return (
    <div className="container px-5 pt-5 custom-modal">
      <Box mb={2} className={classes.title}>
        <img
          className={classes.eklogo}
          src="/assets/images/icon/logo-eksplode.png"
          alt="eksplode!"
        />
      </Box>
      <div className="row">
        <h3>
          <strong>Digital Ad Card (DAC) Program User Agreement</strong>
        </h3>
        <p>
          <strong>Effective Date:</strong> 01/01/2025
        </p>
      </div>
      <div className="row">
        <h6 className="text-dark">
          Welcome to the Digital Ad Card (DAC) Program! <br />
          This User Agreement (the “Agreement”) outlines the terms and
          conditions governing your participation in the DAC Program, operated
          by eksplode! Interactive is a Continent 5 Media Group, Inc. (C5M)
          division. By registering for and using the DAC Program, you
          acknowledge that you have read, understood, and agree to abide by this
          Agreement.
        </h6>
      </div>
      <br />
      <div className="row">
        <h4>1. Overview of the DAC Program</h4>
        <ul>
          <li>
            The DAC Program allows participants to share customized digital
            advertisements (“DACs”) of products and services from participating
            retailers’ catalogs. Participants send DACs to their contacts via
            email or text message, enabling recipients to purchase directly
            through hyperlinks. Rewards are credited to participants based on
            the promotional values displayed in the retailer’s catalog.
          </li>
          <li>
            C5M is committed to a privacy-first approach, ensuring no cookies or
            intrusive tracking methods are used.
          </li>
        </ul>
      </div>
      <br />
      <div className="row">
        <h4>2. Eligibility:</h4>
        <div>
          <h6 className="text-dark">The DAC Program is open to:</h6>

          <ul>
            <li>
              Legal residents of jurisdictions where participation is legally
              permitted.
            </li>
            <li>
              Individuals 18 years of age or older, or those aged 13 to 17 with
              verifiable parental or legal guardian consent.
            </li>
            <li>
              Participants who meet all requirements outlined in this Agreement.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>3. Registration and User Account:</h4>
        <div>
          <h6 className="text-dark mt-2">
            <strong>1. Sign-Up Process:</strong>
          </h6>

          <ul>
            <li>
              Participants must register at eksplode.com to become eksplode!
              Members.
            </li>
            <li>
              Upon registration, Members are assigned a unique QR Code (called
              an eksplode! Code) to track activity and sales.
            </li>
          </ul>
        </div>
        <div>
          <h6 className="text-dark mt-2">
            <strong>2. Account Responsibilities:</strong>
          </h6>

          <ul>
            <li>
              Participants must provide accurate and complete information during
              registration.
            </li>
            <li>
              Users are responsible for maintaining the confidentiality of their
              account credentials.
            </li>
            <li>
              Unauthorized use of your account should be reported immediately to
              Admin@C5M.World.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>4. How the DAC Program Works:</h4>
        <div>
          <ul>
            <li>
              <strong>Dashboard Access:</strong> Members log into their
              eksplode! account to access their dashboard.
            </li>
            <li>
              <strong>Retailers Catalog:</strong> Members activate the
              ‘Retailers Catalog’ tab to browse available products and services.
            </li>
            <li>
              <strong>Selection and Customization:</strong> Members select a
              product or service to promote and choose a greeting (or customize
              their own).
            </li>
            <li>
              <strong>Contact List Activation: </strong> Members activate their
              ‘Contact List’ and select recipients from their uploaded contacts.
            </li>
            <li>
              <strong>Sending DACs:</strong> After choosing recipients, Members
              click the ‘Send’ tab to deliver the DAC via email or text message.
            </li>
            <li>
              <strong>Encrypted Tracking:</strong> Each DAC is automatically
              encrypted with the Member’s eksplode! Code, allowing C5M’s system
              to track purchases made through the shared DAC.
            </li>
            <li>
              <strong>Earning Rewards: </strong> If a recipient makes a
              purchase, the reward value displayed in the retailer’s catalog is
              credited to the Member’s account.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>5. Rewards and Payments:</h4>
        <div>
          <h6 className="text-dark mt-2">
            <strong>1. Reward Structure:</strong>
          </h6>

          <ul>
            <li>
              Rewards are based on the values displayed in the retailer’s
              catalog.
            </li>
            <li>
              Participants earn only the specific reward amounts (e.g., dollar
              value or percentage) set by the retailer.
            </li>
          </ul>
        </div>
        <div>
          <h6 className="text-dark mt-2">
            <strong>2. Payment Processing:</strong>
          </h6>

          <ul>
            <li>
              Rewards are deposited into the account provided by the Member.
            </li>
            <li>
              Parents may manage minors’ earnings through C5M’s eMoney Network.
            </li>
            <li>
              Deposits are typically made within 24 hours of purchase
              verification.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>6. Data Privacy and Contact List Usage:</h4>
        <div>
          <h6 className="text-dark mt-2">
            <strong>1. No Cookies or Tracking:</strong>
          </h6>

          <ul>
            <li>
              C5M does not use cookies or intrusive tracking technologies.
            </li>
            <li>User privacy and trust are paramount.</li>
          </ul>
        </div>
        <div>
          <h6 className="text-dark mt-2">
            <strong>2. Limited Data Collection:</strong>
          </h6>

          <ul>
            <li>
              C5M does not store or distribute participants’ contact lists
              uploaded for dashboard use.
            </li>
            <li>
              Uploaded contact data is for the participant’s personal use only
              and exists solely within their session.
            </li>
          </ul>
        </div>
        <div>
          <h6 className="text-dark mt-2">
            <strong>3. User Responsibility:</strong>
          </h6>

          <ul>
            <li>
              Participants must ensure they have the consent of their contacts
              before sending DACs.
            </li>
            <li>
              Misuse of contact data for spam or unsolicited messaging is
              strictly prohibited.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>7. Terms and Conditions:</h4>
        <div>
          <h6 className="text-dark mt-2">1. Participants must:</h6>

          <ul>
            <li>
              Be 18 years of age or, if under 18, have obtained verifiable
              parental consent.
            </li>
            <li>
              Agree that C5M and its affiliates are not responsible for
              incomplete or misdirected DACs or technical failures.
            </li>
            <li>
              Accept that any DAC deemed inappropriate or non-compliant with
              program policies may be removed, and rewards nullified.
            </li>
            <li>
              Take sole responsibility for any applicable federal, state, or
              local taxes on rewards.
            </li>
          </ul>
        </div>
        <div>
          <h6 className="text-dark mt-2">2. C5M reserves the right to:</h6>

          <ul>
            <li>
              Cancel, modify, or suspend the DAC Program due to fraud, technical
              failures, or other causes beyond its control.
            </li>
            <li>
              Prosecute fraudulent activities or attempts to interfere with the
              program.
            </li>
            <li>
              Disqualify participants violating the terms of this Agreement.
            </li>
          </ul>
        </div>
      </div>
      <br />
      <div className="row">
        <h4>8. Intellectual Property</h4>
        <ul>
          <li>
            All DAC content and associated materials are the intellectual
            property of C5M or its advertisers. Participants are granted a
            limited, non-transferable license to use DAC content solely for
            program purposes. Unauthorized use is prohibited.
          </li>
        </ul>
      </div>
      <br />
      <div className="row">
        <h4>9. Liability Release</h4>
        <ul>
          <li>
            Participants release C5M and its affiliates from all claims,
            demands, and liabilities arising from participation in the DAC
            Program, including any injury, illness, or damages.
          </li>
        </ul>
      </div>
      <br />
      <div className="row">
        <h4>10. Dispute Resolution</h4>
        <ul>
          <li>
            Disputes arising from the DAC Program will be resolved through
            binding arbitration in Las Vegas, Nevada, in accordance with the
            Federal Arbitration Act. By participating, users waive their right
            to a jury trial.
          </li>
        </ul>
      </div>
      <br />
      <div className="row">
        <h4>11. Modifications to this Agreement</h4>
        <ul>
          <li>
            C5M reserves the right to update or modify this Agreement at any
            time. Participants will be notified of significant changes via email
            or platform notifications. Continued use of the DAC Program
            constitutes acceptance of the updated terms.
          </li>
        </ul>
      </div>
      <br />
      <div className="row">
        <h4>12. Contact Information</h4>
        <ul>
          <li>
            For any questions or assistance, please email{" "}
            <a href="mailto:Admin@C5M.World">Admin@C5M.World</a>.
          </li>
          <li>
            By registering for the DAC Program and clicking the "I Agree" tab,
            you confirm that you have read, understood, and agree to this User
            Agreement.
          </li>
        </ul>
      </div>
      <br />
      <div className="row d-flex flex-column">
        <div className="d-flex justify-content-start mt-3 align-items-center">
          <input
            type="checkbox"
            className="form-control w-auto mr-3"
            id="read"
            name="read"
            ref={register({
              required: {
                value: true,
                message: "Please accept the agreement to continue",
              },
            })}
          />
          <p className="mb-0">I agree to the above mentioned terms</p>
        </div>
        <label htmlFor="read" className="error mt-2">
          {errors.read && errors.read.message}
        </label>
      </div>
      <div className="row mt-3 justify-content-center">
        <button
          className="btn btn-solid mx-1"
          style={{ minWidth: "150px" }}
          onClick={handleSubmit(next)}
        >
          I Agree
        </button>
        <button
          className="btn btn-solid mx-1"
          style={{ minWidth: "150px" }}
          onClick={previous}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default Agreement;
